import { render, staticRenderFns } from "./projectSearch.vue?vue&type=template&id=04518406&scoped=true&"
import script from "./projectSearch.vue?vue&type=script&lang=js&"
export * from "./projectSearch.vue?vue&type=script&lang=js&"
import style0 from "./projectSearch.vue?vue&type=style&index=0&id=04518406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04518406",
  null
  
)

export default component.exports